module.exports = __webpack_public_path__ + "img/ar-scan-button.9fd296e7.svg";